"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorPicker = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var colors_1 = require("../colors");
var clsx_1 = __importDefault(require("clsx"));
var useStyles = (0, styles_1.makeStyles)(function () { return ({
    button: function (props) { return ({
        backgroundColor: (0, colors_1.getColor)(props.color),
        border: props.isSelected ? "4px solid ".concat((0, colors_1.getColor)('WHITE_100')) : 'none',
        borderRadius: '50%',
        boxShadow: '0px 3px 7px rgba(0, 0, 0, 0.2)',
        boxSizing: 'content-box',
        cursor: 'pointer',
        height: '48px',
        padding: 0,
        radius: '50%',
        width: '48px',
        '&:disabled': {
            cursor: 'not-allowed',
        },
    }); },
}); });
var ColorPicker = function (_a) {
    var className = _a.className, color = _a.color, disabled = _a.disabled, isSelected = _a.isSelected, onClick = _a.onClick;
    var classes = useStyles({ color: color, isSelected: isSelected });
    return react_1.default.createElement("button", { className: (0, clsx_1.default)(classes.button, className), disabled: disabled, onClick: onClick, type: 'button' });
};
exports.ColorPicker = ColorPicker;
